module.exports = __webpack_public_path__ + "img/3.2f1f2f73.png";